import { render, staticRenderFns } from "./ConsultarProcesosClinicos.vue?vue&type=template&id=198fd736&scoped=true"
import script from "./ConsultarProcesosClinicos.vue?vue&type=script&lang=js"
export * from "./ConsultarProcesosClinicos.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/dropfile.css?vue&type=style&index=0&id=198fd736&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "198fd736",
  null
  
)

export default component.exports